import { ReduxHelper } from "helpers";
import {
  IDeleteByIdRequest,
  IImportPalletDetail,
  IImportReceiveDocumentRequest,
  IPaginateApiResponse,
  IPaginationRequest,
  IReceiveDetail,
  IGetReceiveDetailRequest,
  IUpdateReceiveDocument,
  IReceiveDocument,
} from "model";

export const prefix = "RECEIVE_CONFIGURATION";

export const getAllReceives = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<any>
>(prefix, "GET_ALL_RECEIVE_DOCUMENT");
export const getReceiveDetail = ReduxHelper.generateActions<
  IGetReceiveDetailRequest,
  IPaginateApiResponse<IReceiveDetail[]>
>(prefix, "GET_RECEIVE_DOCUMENT_DETAIL");
export const getImportPalletDetail = ReduxHelper.generateActions<
  IGetReceiveDetailRequest,
  IPaginateApiResponse<IImportPalletDetail[]>
>(prefix, "GET_IMPORT_PALLET_DETAIL");
export const updateReceiveDocument = ReduxHelper.generateActions<
  IUpdateReceiveDocument,
  IReceiveDocument
>(prefix, "UPDATE_RECEIVE_DOCUMENT");
export const deleteReceiveDocument = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  any
>(prefix, "DELETE_RECEIVE_DOCUMENT");
export const importReceiveDocument = ReduxHelper.generateActions<
  IImportReceiveDocumentRequest,
  any
>(prefix, "IMPORT_RECEIVE_DOCUMENT");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
